import './Profile.scss'
import Breadcrumb from '../Breadcrumb'
import DeleteMyAccount from './DeleteMyAccount'
import Divider from '../../widgets/Layout/Divider'
import Head from '../Head'
import Preferences from './Preferences'
import ProfileForm from './Form/ProfileForm'
import ProfileImageForm from './Form/ProfileImageForm'
import React from 'react'
import RequestResetPassword from './RequestResetPassword'
import translate from '../../utilities/translate'
import translations from './translations'
import LongDate from '../../widgets/Temporal/LongDate'
import Heading from '../../widgets/Typography/Heading'
import Loader from '../../widgets/Generic/Loader'

// trans :: String -> String -> String
const trans = translate(translations)

export default ({
  locale,
  createdAt,
  ready,
}) =>
  <Head title={ trans(locale)('title') } robots="noindex">
    <section data-is="my-profile" className="page-content">
      <div className="container container-page">
        <Breadcrumb crumbs={ [{ label: trans(locale)('title') }] } />
        <Heading level="1">{trans(locale)('title')}</Heading>
        { ready
          ? <>
            <span className="member-since">
              { trans(locale)('memberSince') }
            &nbsp;
              <LongDate date={ createdAt } locale={ locale } />
            </span>

            <div className="columns profile">
              <div className="column profile-picture">
                <ProfileImageForm />
              </div>
              <div className="column col-sm-12">
                <ProfileForm/>
                <Preferences/>
                <Divider visibility="all" />
                <div>
                  <DeleteMyAccount/>
                  <RequestResetPassword/>
                </div>
              </div>
            </div>
          </>
          : <Loader />
        }
      </div>
    </section>
  </Head>
